import { useIsClient } from 'store/features/auth/selectors/user';
import { useIsAutorizedUser } from 'store/features/auth/selectors';

import { isEastTerritory } from 'common/utils/checkTerritory';
import { isFrameUser } from 'common/utils/frameUser';


export const useShowCarEBoxLocationsButton = () => {
  const isClient = useIsClient();
  const isAutorizedUser = useIsAutorizedUser();

  return !(isEastTerritory || isFrameUser || (isAutorizedUser && !isClient));
};
